const PAYLOAD_KEYS = Object.freeze(['concentration', 'description', 'name', 'notes'])
const ENVELOPE_KEYS = Object.freeze(['link', 'payload'])

function exactKeys(value, expected) {
  return value && typeof value === 'object' && !Array.isArray(value)
    && Object.keys(value).sort().join(',') === expected.join(',')
}

export function assertFragranceSharePayload(payload) {
  if (!exactKeys(payload, PAYLOAD_KEYS)
      || typeof payload.name !== 'string'
      || (payload.concentration !== null && typeof payload.concentration !== 'string')
      || (payload.description !== null && typeof payload.description !== 'string')
      || !Array.isArray(payload.notes)
      || payload.notes.some(note => typeof note !== 'string')) {
    throw new Error('Shared fragrance payload failed the fragrance-only allowlist.')
  }
  return payload
}

export function assertFragranceShareEnvelope(envelope) {
  if (!exactKeys(envelope, ENVELOPE_KEYS) || typeof envelope.link !== 'string') {
    throw new Error('Shared fragrance link failed the public allowlist.')
  }
  const url = new URL(envelope.link)
  if (!/^\/share\/fragrance\/[0-9a-f]{24}$/.test(url.pathname)) {
    throw new Error('Shared fragrance link is invalid.')
  }
  return { link: envelope.link, payload: assertFragranceSharePayload(envelope.payload) }
}

export function isFragranceShareToken(token) {
  return /^[0-9a-f]{24}$/.test(token || '')
}

export function createFragranceShareCardClient(client) {
  async function rpc(name, args) {
    const { data, error } = await client.rpc(name, args)
    if (error) throw error
    return data
  }

  return {
    async prepare(fragranceId) {
      return assertFragranceShareEnvelope(await rpc('prepare_fragrance_share_card', { p_fragrance_id: fragranceId }))
    },
    async resolve(token) {
      if (!isFragranceShareToken(token)) throw new Error('Shared fragrance link is invalid.')
      return assertFragranceSharePayload(await rpc('resolve_fragrance_share_card', { p_token: token }))
    },
    async accept(token) {
      if (!isFragranceShareToken(token)) throw new Error('Shared fragrance link is invalid.')
      return assertFragranceSharePayload(await rpc('accept_fragrance_share_card', { p_token: token }))
    },
  }
}
